import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import {
  Box,
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
  AppBar,
  Toolbar,
  Typography,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Inventory as ArtworksIcon,
  // Settings as SettingsIcon,
  Logout as LogoutIcon,
  Home as HomeIcon,
  Menu as MenuIcon,
  Edit as ContentIcon,
} from '@mui/icons-material';

const drawerWidth = 240;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  console.log('Mobile detection:', { 
    isMobile, 
    breakpoint: 'sm', 
    windowWidth: window.innerWidth,
    themeBreakpoints: theme.breakpoints.values 
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  if (!user?.is_admin) {
    navigate('/');
    return null;
  }

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin' },
    { text: 'Artworks', icon: <ArtworksIcon />, path: '/admin/artworks' },
    { text: 'Content', icon: <ContentIcon />, path: '/admin/content' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  const handleBackToSite = () => {
    navigate('/');
  };

  const handleDrawerToggle = () => {
    console.log('Mobile drawer toggle:', { mobileOpen, isMobile });
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Button
          variant="outlined"
          startIcon={<HomeIcon />}
          onClick={handleBackToSite}
          sx={{ width: '100%' }}
        >
          Back to Site
        </Button>
        <Button
          color="error"
          variant="contained"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{ width: '100%' }}
        >
          Logout
        </Button>
      </Box>
      <Divider />

      <List>
        {menuItems.map((item) => {
          console.log('Rendering menu item:', item.text, 'isMobile:', isMobile);

          return (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                component={Link}
                to={item.path}
                selected={location.pathname === item.path}
                onClick={() => {
                  if (isMobile) {
                    setMobileOpen(false);
                  }
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Mobile App Bar */}
      
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            width: '100%',
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: 'primary.main',
            display: 'block'
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => {
                console.log('Hamburger menu clicked!', { mobileOpen, isMobile });
                handleDrawerToggle();
              }}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              Admin Panel
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {/* Drawer */}
      
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          zIndex: isMobile ? theme.zIndex.drawer + 2 : theme.zIndex.drawer,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            marginTop: isMobile ? 0 : '64px',
            height: isMobile ? '100%' : 'calc(100% - 64px)',
            position: 'fixed',
            zIndex: isMobile ? theme.zIndex.drawer + 2 : theme.zIndex.drawer,
            '& > *:first-of-type': {
              marginTop: '20px'
            }
          },
        }}
        anchor="left"
      >
        {drawer}
      </Drawer>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 1, sm: 2, md: 3 },
            minHeight: '100vh',
            bgcolor: '#f5f5f5',
            marginTop: isMobile ? '56px' : '64px',
            paddingTop: '20px',
          }}
        >
          <Outlet />
        </Box>
    </Box>
  );
};

export default AdminLayout; 